import { render, staticRenderFns } from "./UserRequestCard.vue?vue&type=template&id=541b2777&scoped=true"
import script from "./UserRequestCard.vue?vue&type=script&lang=js"
export * from "./UserRequestCard.vue?vue&type=script&lang=js"
import style0 from "./UserRequestCard.vue?vue&type=style&index=0&id=541b2777&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541b2777",
  null
  
)

export default component.exports